<template>
  <div>
    <section class="before-footer">
      <div class="container">
        <div
          v-if="layanan"
          class="row"
        >
          <div
            class="col-md-6"
            v-for="p in layanan"
            :key="p.id_layanan"
          >
            <div
              class="layanan-item card"
              @click="showLayanan(p)"
            >
              <div class="card-body">
                <div class="d-flex">
                  <div class="layanan-icon mr-3 text-center">
                    <img :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+p.icon">
                  </div>
                  <div style="width: 70%">
                    <h6>{{ p.nama_layanan }}</h6>
                  </div>
                  <div style="margin-left:auto">
                    <b-button
                      variant="primary"
                      title="Lihat Syarat"
                    >
                      <i class="fa fa-eye" />
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="row"
        >
          <div
            class="col-md-6"
            v-for="i in 4"
            :key="i"
          >
            <div class="layanan-item card">
              <div class="card-body">
                <div class="d-flex">
                  <div class="layanan-icon mr-3 text-center">
                    <div class="content-loader" />
                  </div>
                  <div style="width: 70%">
                    <h6 class="content-loader">
                      Nama Layanan
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
    @media (max-width: 768px) {
        section.before-footer {
            padding-top:0px;
            margin-top:-80px;
        }
    }
</style>

<script>
export default {
    data(){
        return {

        }
    },
    computed: {
        layanan(){
            return this.$store.getters.getLayanan
        },
        selectedPaket(){
            return this.$store.getters.getSelectedPaket
        }
    },
    methods: {
        showLayanan(e){
            this.$router.push({path: `/layanan/${this.$route.params.slugpaket}/${e.slug}`})
        }
    },
    created(){
        this.$store.dispatch('showPaketPublic', this.$route.params.slugpaket)
        this.$store.dispatch('fetchLayananByPaketPublic', this.$route.params.slugpaket).then(res => {
            if(res.data.data){
                this.$store.dispatch('setLayanan', res.data.data)
            }
        })
    }
}
</script>